import React from 'react'
import MaterialSymbol from '../material-symbol'

const Check = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="check" {...props} />
))

Check.displayName = 'Check'

export default Check
